import { createHook } from '@atomify/hooks';
import {
    Dimensions,
    InteractionState,
    ScreenCoordinates,
} from '@features/virtual-tour/types/interaction';

export interface MousePositionHookProps {
    viewport: { current: HTMLElement | null };
    onUpdate: (position: InteractionState) => void;
    ignoredElements?: string[];
}

export const useMousePosition = ({ viewport, onUpdate }: MousePositionHookProps) => {
    const interactionState: InteractionState = { inputMode: 'mouse' };

    function updatePosition(
        e: MouseEvent | TouchEvent,
        viewportDimensions: Dimensions,
        viewportPosition: ScreenCoordinates,
    ) {

        // if (e instanceof AppTouchEvent) return;  NOTE this is STILL a bug in Safari desktop anno jan 2024. Instead of instanceof AppTouchEvent, we use 'touches' in e
        if ('touches' in e) return;

        if (!viewport.current || interactionState.ignoreTouch) return;

        const { x: viewportX, y: viewportY } = viewportPosition;
        const { width, height } = viewportDimensions;

        const { clientX: mouseX, clientY: mouseY } = e;

        // mouse coordinate system translated to top left corner of viewport
        const translated: ScreenCoordinates = {
            x: mouseX - viewportX,
            y: mouseY - viewportY,
        };

        // mouse offset from the viewport center
        interactionState.centerOffset = {
            x: translated.x / width - 0.5,
            y: translated.y / height - 0.5,
        };

        interactionState.position = translated;

        return onUpdate(interactionState);
    }

    return createHook({
        onDidLoad: () => ({ interactionState, updatePosition }),
    });
};
